import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { ReactNode } from 'react';
import React from 'react';

import styles from './InfoItem.scss';

interface InfoDetail {
  label: string | TranslationTag;
  value: ReactNode;
  className?: string;
}

export interface InfoItemProps {
  icon: React.ReactNode;
  infoDetails: InfoDetail[];
}

const InfoItem: React.FC<InfoItemProps> = ({ icon, infoDetails }) => (
  <div className={styles.container}>
    {icon}
    <div className={styles.detailContainer}>
      {infoDetails.map((detail, i) => (
        <div key={`${detail.value}-${i}`} className={styles.detail}>
          <span className={styles.label}>
            {typeof detail.label === 'string' ? detail.label : <Translation {...detail.label} />}
          </span>
          <span className={classNames(styles.value, detail.className)}>{detail.value}</span>
        </div>
      ))}
    </div>
  </div>
);

export default InfoItem;
